import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {SidebarOrderState} from "./SidebarOrderState";
import {
	JOB_SIDEBAR_ORDER_FETCHED,
	JOB_SIDEBAR_ORDER_UPDATED,
	LEAD_SIDEBAR_ORDER_FETCHED,
	LEAD_SIDEBAR_ORDER_UPDATED
} from "../../action/sidebar/actionType";

const initState: SidebarOrderState = {
	jobSidebarOrder: none,
	leadSidebarOrder: none
};

const reducer = handleActions({
	[JOB_SIDEBAR_ORDER_FETCHED]: (state: SidebarOrderState,
		action: Action<JOB_SIDEBAR_ORDER_FETCHED>): SidebarOrderState => {
		return {...state, jobSidebarOrder: option(action.payload.order)}
	},
	[JOB_SIDEBAR_ORDER_UPDATED]: (state: SidebarOrderState, action: Action<JOB_SIDEBAR_ORDER_UPDATED>): SidebarOrderState => {
		return {...state, jobSidebarOrder: option(action.payload.order)};
	},
	[LEAD_SIDEBAR_ORDER_FETCHED]: (state: SidebarOrderState,
		action: Action<LEAD_SIDEBAR_ORDER_FETCHED>): SidebarOrderState => {
		return {...state, leadSidebarOrder: option(action.payload.order)}
	},
	[LEAD_SIDEBAR_ORDER_UPDATED]: (state: SidebarOrderState, action: Action<LEAD_SIDEBAR_ORDER_UPDATED>): SidebarOrderState => {
		return {...state, leadSidebarOrder: option(action.payload.order)};
	}
}, initState);

export default reducer;
